<template>
  <v-app>
    <main>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12">
              <v-toolbar
                dark
                color="primary"
              >
                <v-toolbar-title>Admin Login</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form
                  ref="form"
                  v-model="valid"
                >
                  <v-text-field
                    v-model="email"
                    label="Enter your e-mail address"
                    :rules="emailRules"
                    required
                    outlined
                  />
                  <v-text-field
                    v-model="password"
                    label="Enter your password"
                    min="8"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"
                    :rules="passwordRules"
                    counter
                    required
                    outlined
                    @click:append="showPassword = !showPassword"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  :class=" { 'primary' : valid, disabled: !valid }"
                  :disabled="!valid"
                  @click="submit"
                >
                  Login
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <dashboard-core-footer />
      </v-container>
    </main>
    <centre-spinner
      :loading="loading"
    />
  </v-app>
</template>
<script>
  import axios from 'src/app-axios';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';

  export default {
    name: 'Login',

    components: {
      'centre-spinner': spinner,
      DashboardCoreFooter: () => import('../dashboard/components/core/Footer'),
    },

    data: () => ({
      valid: false,
      showPassword: false,
      password: '',
      passwordRules: [
        (v) => !!v || 'Password is required',
      ],
      email: '',
      emailRules: [
        (v) => !!v || 'E-mail is required',
        (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid',
      ],
      loading: false,
      logo: require('@/assets/DBSLogo.png'),
    }),

    methods: {
      submit () {
        if (this.$refs.form.validate()) {
          axios.get('sanctum/csrf-cookie').then(response => {
            this.$store
              .dispatch('adminuser/login', {
                email: this.email,
                password: this.password,
              })
              .then(response => {
                this.$router.push({ name: 'Organizations' });
              });
          });
        }
      },
    },
  };
</script>
